import React from 'react';
import RequestContextProvider from '../../context/RequestContext';
import { AuthContextProvider } from '../../context/AuthContext';

export const CombinedContexts = ({ children }: { children: JSX.Element }) => (
  <AuthContextProvider>
    <RequestContextProvider>{children}</RequestContextProvider>
  </AuthContextProvider>
);
